export var LOGGER_NAME = 'relay';
export var DEFAULT_CACHE_OPTIONS = {
    size: 250,
    ttl: 60 * 1000,
    clearOnMutation: true,
};
//# sourceMappingURL=constants.js.map